
import { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation
} from "react-router-dom";
import BottomNav from "./components/BottomNav";
import { Toaster } from "@/components/ui/toaster";
import { Analytics } from "./components/Analytics";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AnimatePresence } from "framer-motion";
import Index from "./pages/Index";
import Profile from "./pages/Profile";
import Auth from "./pages/Auth";
import NotFound from "./pages/NotFound";
import NewTrip from "./pages/NewTrip";
import Assistant from "./pages/Assistant";
import Discover from "./pages/Discover";
import TripTimelinePage from "./pages/TripTimelinePage";
import { I18nextProvider } from "react-i18next";
import i18n from "@/i18n";
import { HeyUtils } from "./lib/hey/core";
import Hey from "./lib/hey-utils";

const queryClient = new QueryClient();

// Move ADTD query URL into localStorage
if (location.search) {
  const urlParams = new URLSearchParams(location.search);

  // PNR Import
  if (urlParams.has("E") && urlParams.has("F") && urlParams.has("N") && urlParams.has("R")) {
    let atdtData = {
      "encryptedEmail": urlParams.get("E"),
      "encryptedFirstName": urlParams.get("F"),
      "encryptedLastName": urlParams.get("N"),
      "encryptedRecloc": urlParams.get("R")
    }
    localStorage.setItem("atdtData", JSON.stringify(atdtData));
    urlParams.delete("E");
    urlParams.delete("F");
    urlParams.delete("N");
    urlParams.delete("R");
    history.replaceState({}, document.title, location.pathname + "?" + urlParams.toString());
  }

  // OTP Validation
  if (urlParams.has("userEmail") && urlParams.has("code")) {
    const userEmail = urlParams.get("userEmail");
    const code = urlParams.get("code");
    const branchMatchId = urlParams.get("_branch_match_id");
    const branchReferrer = urlParams.get("_branch_referrer");

    console.log("User Email:", userEmail);
    console.log("Code:", code);
    localStorage.setItem("otp_userEmail", userEmail);
    localStorage.setItem("otp_code", code);
    // Redirect to Main page if code has been handled
    setInterval(() => {
      if (HeyUtils.getInstance().isUserAuthenticated()) {
        console.log("User is authenticated");
        // navigate("/"); // Or kill page ?
        clearInterval(this);
      }
    }, 500);
  }
}

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function AnimatedRoutes() {
  const location = useLocation();
  
  return (
    <AnimatePresence mode="wait" initial={false}>
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Index />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/auth" element={<Auth />} />
        <Route path="/new-trip" element={<NewTrip />} />
        <Route path="/assistant" element={<Assistant />} />
        <Route path="/discover" element={<Discover />} />
        <Route path="/trip-timeline" element={<TripTimelinePage />} />
        <Route path="/*" element={<NotFound />} />
      </Routes>
    </AnimatePresence>
  );
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <I18nextProvider i18n={i18n}>
        <Router>
          <Analytics />
          <ScrollToTop />
          <main>
            <AnimatedRoutes />
            <BottomNav />
          </main>
          <Toaster />
        </Router>
      </I18nextProvider>
    </QueryClientProvider>
  );
}

export default App;
